import { useEffect, useState } from "react";
import { DateView } from "nystem-components";
import app from "nystem";

const ViewButtonEnergyHistory = ({ model }) => {
  const [consumption, setConsumption] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    let mounted = true;
    let timer;
    setConsumption(null);
    const update = async () => {
      try {
        const { consumption, error } = await app.connection.emit({
          type: "energyConsumption",
          resolution: model.resolution,
        });
        if (mounted) {
          setConsumption(error ? null : consumption);
        }
      } finally {
        if (mounted) timer = setTimeout(update, 3600000);
      }
    };
    update();
    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, [model.resolution]);

  const highest = Math.max(0.01, ...(consumption || []).map(({ value }) => value));
  const magnitude = 10 ** Math.floor(Math.log10(highest / 4));
  const step = [1, 2, 2.5, 5, 10].find((value) => value * magnitude >= highest / 4) * magnitude;
  const maximum = Math.ceil(highest / step) * step;
  const ticks = Array.from({ length: Math.round(maximum / step) + 1 }, (_, pos) => pos * step);
  const readings = [...(consumption || [])].reverse();
  const height = readings.length * 20;
  return (
    <section aria-label={`Tibber ${model.resolution === "DAILY" ? "daily" : "hourly"} electricity consumption`}>
      {consumption ? (
        <>
          <div className="relative mt-4 pr-14 pl-12">
            <div className="relative h-6 text-xs leading-none text-gray-300 tabular-nums">
              {ticks.map((value) => (
                <span key={value} className="absolute -translate-x-1/2" style={{ left: `${(value / maximum) * 100}%` }}>
                  {Number(value.toPrecision(12))}
                </span>
              ))}
            </div>
            <div className="relative" style={{ height }}>
              {ticks.map((value) => (
                <div
                  key={value}
                  className="pointer-events-none absolute top-0 bottom-0 border-l border-gray-500/60"
                  style={{ left: `${(value / maximum) * 100}%` }}
                />
              ))}
              {readings.map(({ time, value }, pos) => {
                return (
                  <button
                    key={time}
                    type="button"
                    aria-label={`${value.toFixed(2)} kWh, ${model.resolution === "DAILY" ? "day" : "hour"} ${pos + 1}`}
                    className={`absolute left-0 rounded-r-sm focus:outline-2 focus:outline-white ${selected === time ? "bg-emerald-300/60" : "bg-emerald-500/45 hover:bg-emerald-300/60"}`}
                    style={{ top: pos * 20, width: `${Math.max(0.5, (value / maximum) * 100)}%`, height: 17 }}
                    onMouseEnter={() => setSelected(time)}
                    onFocus={() => setSelected(time)}
                    onClick={() => setSelected(time)}
                  />
                );
              })}
            </div>
            <div
              className="pointer-events-none absolute top-6 right-0 left-0 text-xs text-gray-300 tabular-nums"
              style={{ height }}
            >
              {readings.map(({ time, value }, pos) => {
                return (
                  <div
                    key={time}
                    className="absolute right-0 left-0 flex -translate-y-1/2 justify-between"
                    style={{ top: pos * 20 + 10 }}
                  >
                    <DateView
                      model={{ dateFormat: model.resolution === "DAILY" ? "dateNoYear" : "time", renderAs: "span" }}
                      value={time}
                    />
                    <span className="w-12 text-right">{value.toFixed(2)}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      ) : null}
    </section>
  );
};

export default ViewButtonEnergyHistory;
